/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';


// Components
export function FixedTable({ invisibleHeaders, headers, headerRow, ...props }) {
  return (
    <Table
      {...props}
      defaultClasses="fixed-table"
      header={ (headers || invisibleHeaders) &&
        <thead>
          { invisibleHeaders &&
            <tr className="invisible-row">
              {_.map(invisibleHeaders, (header, index) =>
                <th key={index} className={header} />
              )}
            </tr>
          }
          { headers &&
            <tr>
              {_.map(headers, (header, index) =>
                <th key={index}>{header}</th>
              )}
            </tr>
          }
          {headerRow}
        </thead>
      }
    />
  );
}

export function ClickableTable(props) {
  return <Table {...props} defaultClasses="clickable-table" />;
}

export function Table({ className, headers, children, defaultClasses, header, ...props }) {
  return (
    <table {...props} className={classNames(className, defaultClasses, 'table')}>
      { header || (headers &&
        <thead>
          <tr>
            {_.map(headers, (headerContent) =>
              <th key={headerContent}>{headerContent}</th>
            )}
          </tr>
        </thead>
      )}
      {children}
    </table>
  );
}



// WEBPACK FOOTER //
// ./app/components/content-containers/tables/tables.js